import { Link } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { Instagram, Mail, Phone, MapPin } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_7f06c548-253d-46ff-97f6-8e1ce04a5d90/artifacts/754hzicm_4D591E6D-6750-40B9-B6EF-BB93EB677B89.png";

export const Footer = () => {
    const { t, lang } = useApp();
    return (
        <footer data-testid="main-footer" className="border-t border-[#D4AF37]/15 bg-[#0A0A0A] py-20 mt-24">
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-4 gap-12">
                <div className="md:col-span-2">
                    <img src={LOGO} alt="SRAA TENT" className="h-16 w-auto mb-6" />
                    <p className="text-white/60 text-sm max-w-sm leading-relaxed">
                        {lang === "ar"
                            ? "صناعة إماراتية فاخرة للخيام والمجالس، تجمع بين أصالة التراث وروح العصر."
                            : "Premium Emirati craftsmanship for tents and majlis, blending heritage and modern spirit."}
                    </p>
                </div>

                <div>
                    <div className="overline mb-5">{t.footer.quick_links}</div>
                    <ul className="space-y-3 text-sm text-white/70">
                        <li><Link to="/" className="hover:text-[#D4AF37] transition-colors">{t.nav.home}</Link></li>
                        <li><Link to="/products" className="hover:text-[#D4AF37] transition-colors">{t.nav.products}</Link></li>
                        <li><Link to="/about" className="hover:text-[#D4AF37] transition-colors">{t.nav.about}</Link></li>
                        <li><Link to="/contact" className="hover:text-[#D4AF37] transition-colors">{t.nav.contact}</Link></li>
                    </ul>
                </div>

                <div>
                    <div className="overline mb-5">{t.footer.contact_us}</div>
                    <ul className="space-y-3 text-sm text-white/70">
                        <li className="flex items-center gap-2">
                            <Phone size={14} className="text-[#D4AF37]" />
                            <a href="https://wa.me/971524110193" data-testid="footer-whatsapp" className="hover:text-[#D4AF37]">+971 52 411 0193</a>
                        </li>
                        <li className="flex items-center gap-2">
                            <Mail size={14} className="text-[#D4AF37]" />
                            <a href="mailto:uae.tent11@gmail.com" data-testid="footer-email" className="hover:text-[#D4AF37]">uae.tent11@gmail.com</a>
                        </li>
                        <li className="flex items-center gap-2">
                            <Instagram size={14} className="text-[#D4AF37]" />
                            <a href="https://instagram.com/sraa.tent" data-testid="footer-instagram" className="hover:text-[#D4AF37]">@sraa.tent</a>
                        </li>
                        <li className="flex items-center gap-2">
                            <MapPin size={14} className="text-[#D4AF37]" />
                            <span>{lang === "ar" ? "أبوظبي، الإمارات" : "Abu Dhabi, UAE"}</span>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="hairline max-w-[1400px] mx-auto mt-16 mb-8" />
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/40">
                <span>© 2026 SRAA TENT. {t.footer.rights}.</span>
                <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-[#D4AF37]">{t.admin.login}</Link>
            </div>
        </footer>
    );
};
